import { Button, Image, View } from "@/components/ui";
import Shield from "@/assets/images/3d-icons/shiled.png";
import CsWhatsapp from "@/assets/images/3d-illus/cs-whatsapp.png";
import Employee3d from "@/assets/images/3d-icons/employees.png";
import TransparentPricing3d from "@/assets/images/3d-icons/money-green.png";
import Calendar3d from "@/assets/images/3d-icons/calendar.png";
import { useState } from "react";
import { BottomDrawerModal } from "@/components/shared/bottom-drawer-modal";
import { Divider } from "@/components/shared/divider";
import { Typography } from "@/components/shared/typography";

export function ServiceLuceGuarantee() {
  const [isLuceGuaranteeModalOpen, setIsLuceGuaranteeModalOpen] =
    useState(false);
  const handleOpenLuceGuaranteeModal = () => {
    setIsLuceGuaranteeModalOpen(true);
  };
  const handleCloseLuceGuaranteeModal = () => {
    setIsLuceGuaranteeModalOpen(false);
  };
  return (
    <>
      <View
        className="mx-auto flex cursor-pointer flex-row gap-1"
        onClick={() => handleOpenLuceGuaranteeModal()}
      >
        <Image src={Shield} alt="Luce Guarantee" width={16} height={16} />
        <Typography variant="caption-md">Luce Guarantee</Typography>
      </View>
      <BottomDrawerModal
        open={isLuceGuaranteeModalOpen}
        onOpenChange={handleCloseLuceGuaranteeModal}
      >
        <View className="flex flex-col">
          <View className="flex flex-col items-center justify-center gap-2">
            <Image src={Shield} alt="Luce Guarantee" width={48} height={48} />
            <View className="flex flex-col gap-1">
              <Typography variant="label-lg" align="center">
                Luce Guarantee
              </Typography>
              <Typography
                variant="body-sm"
                align="center"
                color="foreground-intermediate"
              >
                What we guarantee on every Luce booking
              </Typography>
            </View>
          </View>
          <View className="py-4">
            <View className="flex flex-col gap-3 rounded-lg border border-brand-primary px-4 py-3">
              <View className="flex flex-row items-start gap-3">
                <Image src={CsWhatsapp} alt="WhatsApp" width={28} height={28} />
                <View className="flex flex-1 flex-col gap-1">
                  <Typography variant="label-sm">Responsive support</Typography>
                  <Typography variant="body-sm" color="foreground-intermediate">
                    Message us on WhatsApp and we'll do our best to help you
                    quickly.
                  </Typography>
                </View>
              </View>
              <Divider />
              <View className="flex flex-row items-start gap-3">
                <Image
                  src={TransparentPricing3d}
                  alt="Transparent Pricing"
                  width={28}
                  height={28}
                />
                <View className="flex flex-1 flex-col gap-1">
                  <Typography variant="label-sm">
                    Transparent pricing
                  </Typography>
                  <Typography variant="body-sm" color="foreground-intermediate">
                    No upfront charges or platform fees.
                  </Typography>
                </View>
              </View>
              <Divider />
              <View className="flex flex-row items-start gap-3">
                <Image src={Employee3d} alt="Employee" width={28} height={28} />
                <View className="flex flex-1 flex-col gap-1">
                  <Typography variant="label-sm">
                    Employees, Not Freelancers
                  </Typography>
                  <Typography variant="body-sm" color="foreground-intermediate">
                    Full-time, ID-verified Luce employees trained to our
                    standards.
                  </Typography>
                </View>
              </View>
              <Divider />
              <View className="flex flex-row items-start gap-3">
                <Image src={Calendar3d} alt="Calendar" width={28} height={28} />
                <View className="flex flex-1 flex-col gap-1">
                  <Typography variant="label-sm">Set it & forget it</Typography>
                  <Typography variant="body-sm" color="foreground-intermediate">
                    Book once and we'll handle the rest.
                  </Typography>
                </View>
              </View>
            </View>
          </View>
          <View className="mt-4 flex flex-col">
            <Button
              variant="primary"
              size="lg"
              className="w-full"
              color="CTA"
              onClick={() => handleCloseLuceGuaranteeModal()}
            >
              Ok, got it!
            </Button>
          </View>
        </View>
      </BottomDrawerModal>
    </>
  );
}
